/**
 * @author sgdh
 * @description 采购中心枚举
 */

import * as func from '@/func'

const enumToList = func.enumToList()

// 页面标记
export enum PAGE_MODE {
  ADD = 'add',
  CHECK = 'check',
  EDIT = 'edit',
  CHANGE = 'change',
  COPY = 'copy',
  IMPORT = 'import',
  RELEASE = 'release',
  SMALLRELEASE = 'smallRelease',
  // 统编
  UNIFIEDEDITOR = 'unifiedEditor',
  // 再编
  AGAINEDIT = 'againEdit',
  //分编编辑和详情
  POINTSEDIT = 'pointsEdit',
  // 批量编辑
  MOREEDIT = 'moreEdit',
  // 基店编辑
  BASESHOPEDIT = 'baseShopEdit',
  // 分编详情
  FENBIANCHECK = 'fenBianCheck',
  // 组合品种转移
  COMBINATIONAL = 'combinational',
}
export enum ManualStockingType {
  MANUAL_STOCKING = 'manualStocking',
  PURCHASE_INTENTION = 'purchaseIntention',
}
// 人工配货枚举-------------------
// 收货类型枚举
export enum DeliveryMethod {
  REGULAR = 1,
  URGENT_DOCUMENT = 2,
  SHIP_BY_ORDER = 3,
  SHIP_ON_DEMAND = 4,
  DIRECT_SHIPMENT = 5,
}
export enum DeliveryMethodName {
  REGULAR = '普通',
  URGENT_DOCUMENT = '急件',
  SHIP_BY_ORDER = '按单发货',
  SHIP_ON_DEMAND = '按需发货',
  DIRECT_SHIPMENT = '直发',
}

// 订单状态枚举
export enum OrderStatusType {
  PENDING_PURCHASE = 1,
  PARTIAL_PURCHASE = 2,
  COMPLETED = 3,
  CLOSED_OUT = 4,
  SOURCING_FAILURE = 5,
}
export enum OrderStatusTypeName {
  PENDING_PURCHASE = '待采购',
  PARTIAL_PURCHASE = '部分采购',
  COMPLETED = '已完成',
  CLOSED_OUT = '已了结',
  SOURCING_FAILURE = '寻源失败',
}

// 意向单状态枚举
export enum IntentionFormStutusType {
  PENDING_REVIEW = 1,
  REJECTED = 2,
  REPORTED_BACK_PENDING_SHIPMENT = 3,
}
export enum IntentionFormStutusTypeName {
  PENDING_REVIEW = '待审核',
  REJECTED = '已拒绝',
  REPORTED_BACK_PENDING_SHIPMENT = '已回告待发货',
}

// 供应商发货单枚举---------------------
// 供应商发货单类型
export enum SupplierDeliveryNoteType {
  SUPPLIER_DELIVERY_NOTE_TYPE = 1,
  TAKE_DELIVERY_ABNORMAL = 2,
}
export enum SupplierDeliveryNoteTypeName {
  SUPPLIER_DELIVERY_NOTE_TYPE = '供应商发货清单',
  TAKE_DELIVERY_ABNORMAL = '收货异常',
}
// 供应商发货单状态
export enum SupplierDeliveryNoteStatus {
  TO_BE_SUBMITTED = 0,
  PENDING_CONFIRMATION = 1,
  PENDING_INVENTORY_RECEIPT = 2,
  PARTIAL_RECEIPT = 3,
  FULL_RECEIPT = 4,
}
export enum SupplierDeliveryNoteStatusName {
  TO_BE_SUBMITTED = '待提交',
  PENDING_CONFIRMATION = '待确认',
  PENDING_INVENTORY_RECEIPT = '待库存收货',
  PARTIAL_RECEIPT = '部分收货',
  FULL_RECEIPT = '全部收货',
}
export enum SupplierDeliveryNoteStatusColor {
  TO_BE_SUBMITTED = 'purple',
  PENDING_CONFIRMATION = 'blue',
  PENDING_INVENTORY_RECEIPT = 'orange',
  PARTIAL_RECEIPT = 'pink',
  FULL_RECEIPT = 'green',
}

// 自采商品审批
export enum productApproval {
  APPROVAL_LIST = 0, // 审批列表
  SUBMIT_FOR_APPROVAL, // 提交审批
}

// 供应商发货单
export enum DifferentialType {
  VARIETY_REPLACEMENT = '品种替换',
  VARIETY_TRANSFER = '品种转移',
  RECEIVE_REPLENISHMENT = '接收补采购',
  LOW_PRICE_ENTRY = '低价入库',
  GIFT_ENTRY = '赠品入库',
}

// 品种替换/转移
export enum VarietyReplacement {
  TRANSFER = 0, // 转移
  REPLACEMENT = 1, // 替换
}
export enum VarietyReplacementType {
  TRANSFER = 'TRANSFER', // 转移
  REPLACEMENT = 'REPLACEMENT', // 替换
}

export enum DifferentialStatus {
  CONFIRM, // 确认
  CLEAR, // 明确
  START, // 开始
}

// 转移列表
export enum VarietyReplacementStatus {
  REPLACED = 0, // 待转移',
  TRANSFERRED, // '已转移'
  PROCESSING, // 处理中',
  TRANSFER_FAILED, // 转移失败'
}

// 主配确认枚举----------------------
// 主配业务属性
export enum UnderstandingRequested {
  ALL = 1,
  COMPREHENDED = 2,
  READING = 3,
  TEXTBOOK = 4,
  LIBRARY_ALLOCATION = 5,
  INNOVATION = 6,
}
export enum UnderstandingRequestedName {
  ALL = '全部',
  COMPREHENDED = '电商',
  READING = '阅读',
  TEXTBOOK = '教材',
  LIBRARY_ALLOCATION = '馆配',
  INNOVATION = '创新',
}
// 主配来源
export enum PrimaryAllocationSource {
  ALL = 1,
  SALES_PRIMARY_ALLOCATION = 2,
  NEW_PRODUCT_PRE_ALLOCATION = 3,
}
export enum PrimaryAllocationSourceName {
  ALL = '全部',
  SALES_PRIMARY_ALLOCATION = '销售主配',
  NEW_PRODUCT_PRE_ALLOCATION = '新品预分',
}
// 主配单状态
export enum MainConfigurationStatus {
  EXPIRED = 1,
  IN_EFFECT = 2,
}
export enum MainConfigurationStatusName {
  EXPIRED = '已失效',
  IN_EFFECT = '生效中',
}
export enum MainConfigurationStatusColor {
  EXPIRED = 'red',
  IN_EFFECT = 'green',
}

// 采购需求单枚举----------------------
// 来源类型枚举
export enum PROriginType {
  SALES_ORDER = 1,
  MANUAL_STOCK = 2,
  REPLENISHMENT_ADVICE = 3,
}
export enum PROriginTypeName {
  SALES_ORDER = '销售订单',
  MANUAL_STOCK = '人工备货',
  REPLENISHMENT_ADVICE = '补货建议',
}
// 收货类型枚举
export enum PRReceivedType {
  NORMAL_ORDER = 1,
  SELF_PICKUP = 2,
  URGENT_ORDER = 3,
  // DIRECT_SHIPMENT_ORDER = 4,
  ON_DEMAND_SHIPMENT = 5,
  ORDER_SPECIFIC_SHIPMENT = 6,
  // DROP_SHIPPING = 7,
}
export enum PRReceivedTypeName {
  NORMAL_ORDER = '普通订单',
  SELF_PICKUP = '自提',
  URGENT_ORDER = '急件订单',
  // DIRECT_SHIPMENT_ORDER = '直发订单',
  ON_DEMAND_SHIPMENT = '按需发货',
  ORDER_SPECIFIC_SHIPMENT = '按单发货',
  // DROP_SHIPPING = '一键代发',
}
// 客户性质枚举
export enum PRSupplierAttribute {
  EXTERNAL = 1,
  INTERNAL = 2,
  VIRTUAL = 3,
  OVERSEAS = 4,
}
export enum PRSupplierAttributeName {
  EXTERNAL = '外部供应商',
  INTERNAL = '内部供应商',
  VIRTUAL = '虚拟供应商',
  OVERSEAS = '海外',
}
// 业务属性枚举
export enum PRBizAttrType {
  EDUCATIONAL_MATERIAL = 1,
  ECOMMERCE = 2,
  READING = 3,
  LIBRARY_SUPPLY = 4,
  INNOVATION = 5,
  COMPREHENSIVE = 6,
}
export enum PRBizAttrTypeName {
  // EDUCATIONAL_MATERIAL = '教材',
  EDUCATIONAL_MATERIAL = '教育服务',
  ECOMMERCE = '电商',
  READING = '阅读服务',
  LIBRARY_SUPPLY = '馆配',
  INNOVATION = '创新服务',
  COMPREHENSIVE = '综合',
}
// 业务属性-教材枚举
export enum PRBizAttrTypeSub {
  PRIMARY_SECONDARY = 1,
  VOCATIONAL = 2,
  TEACHING_AIDS = 3,
  CHILD = 4,
}
export enum PRBizAttrTypeSubName {
  PRIMARY_SECONDARY = '中小学',
  VOCATIONAL = '大中专',
  TEACHING_AIDS = '教辅',
  CHILD = '幼儿',
}

// "bizAttrType": "业务属性  (一级：1 教材、2 电商、3 阅读、4 馆配、5 创新) (必填)",
// "bizAttrTypeSub": "业务属性-教材（二级：1 中小学、2 大中专、3 教辅、4 幼儿）(业务属性为教材时必填)",

// 订单状态枚举
export enum PurchaseRequisitionOrderStatus {
  TOBE = 1,
  PORTION = 2,
  // DONE = 3,
  // CLOSED = 4,
  FAILED = 5,
}
export enum PurchaseRequisitionOrderStatusName {
  TOBE = '待采购',
  PORTION = '部分采购',
  // DONE = '已完成',
  // CLOSED = '已了结',
  FAILED = '寻源失败',
}
// 订单类型枚举
export enum PurchaseRequisitionOrderType {
  INTERNAL = 1,
  PROVINCE_STORE = 2,
  EXTERNAL = 3,
}
export enum PurchaseRequisitionOrderTypeName {
  INTERNAL = '内部采购',
  PROVINCE_STORE = '省店采购',
  EXTERNAL = '外部采购',
}
// 不满足规则	枚举包括“满足部分，其余取消”、“满足部分，其余转预订”、“不满足，全部订数取消”、“不满足，全部订数转预订”
export enum NotMeetingRules {
  PARTIAL_CANCELLATION = 1,
  PARTIAL_TRANSFER_RESERVATION = 2,
  UNSATISFACTION_CANCELLATION = 3,
  UNSATISFACTION_TRANSFER_RESERVATION = 4,
}
export enum NotMeetingRulesName {
  PARTIAL_CANCELLATION = '满足部分，其余取消',
  PARTIAL_TRANSFER_RESERVATION = '满足部分，其余转预订',
  UNSATISFACTION_CANCELLATION = '不满足，全部订数取消',
  UNSATISFACTION_TRANSFER_RESERVATION = '不满足，全部订数转预订',
}
// 放单规则	枚举包括“整单一次性满足放单”、“单品满足放单”、“单品部分满足部分放单”
export enum OrderReleaseRules {
  ORDER_FULLFILLMENT = 1,
  SINGLE_ITEM_FULFILLMENT = 2,
  PARTIAL_SINGLE_ITEM_FULFILLMENT = 3,
}
export enum OrderReleaseRulesName {
  ORDER_FULLFILLMENT = '整单一次性满足放单',
  SINGLE_ITEM_FULFILLMENT = '单品满足放单',
  PARTIAL_SINGLE_ITEM_FULFILLMENT = '单品部分满足部分放单',
}
// 添加方式：基订、添订
export enum AddMethod {
  BASE_ORDER = 1,
  ADD_ORDER = 2,
}
export enum AddMethodName {
  BASE_ORDER = '基订',
  ADD_ORDER = '添订',
}
// 分发类型：按班分发、按人分发
export enum DistributionType {
  PER_BATCH = 1,
  PER_PERSON = 2,
}
export enum DistributionTypeName {
  PER_BATCH = '按班分发',
  PER_PERSON = '按人分发',
}

// 退货申请单
export enum ReturnType {
  STANDARD = 1, // 标准退货
  // PROJECT = 2, // 项目退货
  DIRECT = 3, // 直发退货
}
export enum ReturnTypeName {
  STANDARD = '标准退货',
  // PROJECT = '项目退货',
  DIRECT = '直发退货',
}

export enum returnOfGoodsOrderStatus {
  TO_SUBMIT = 1, // 待提交
  TO_REVIEW = 2, // 待审核
  APPROVED = 3, // 通过
  REJECTED = 4, // 驳回
  // OUTBOUND_FAILED = 5, // 出库失败，库存短缺
  COMPLETED = 5, // 完成
}

export enum returnOfGoodsOrderStatusName {
  TO_SUBMIT = '待提交',
  TO_REVIEW = '待审核',
  APPROVED = '通过',
  REJECTED = '驳回',
  // OUTBOUND_FAILED = '出库失败，库存短缺',
  COMPLETED = '完成',
}

export enum returnOfGoodsOrderStatusColor {
  TO_SUBMIT = 'orange',
  TO_REVIEW = 'blue',
  APPROVED = 'cyan',
  REJECTED = 'red',
  // OUTBOUND_FAILED = '出库失败，库存短缺',
  COMPLETED = 'green',
}

export enum entryAndExitStatus {
  PENDING_OUTBOUND = 1, // 待出库
  OUTBOUND_CONFIRMED, // 已出库待确认
  RETURN_COMPLETED, // 完成退货
}

export enum entryAndExitStatusName {
  PENDING_OUTBOUND = '待出库', // 待出库
  OUTBOUND_CONFIRMED = '已出库待确认', // 已出库待确认
  RETURN_COMPLETED = '完成退货', //
}

export enum entryAndExitStatusColor {
  PENDING_OUTBOUND = 'orange', // 待出库
  OUTBOUND_CONFIRMED = 'blue', // 已出库待确认
  RETURN_COMPLETED = 'green', //
}

// 采购单管理
export enum purchaseOrderType {
  NORMAL = 1, // 普通订单
  SELF_PICKUP, // 自提
  URGENT, // 急件订单
  DIRECT, // 直发订单
  ON_DEMAND, // 按需发货
  PER_ORDER, // 按单发货
  // PROCUREMENT, // 采购意向订单
  DROP_SHIPPING, // 一件代发
}

export enum purchaseOrderTypeName {
  NORMAL = '普通订单',
  SELF_PICKUP = '自提',
  URGENT = '急件订单',
  DIRECT = '直发订单',
  ON_DEMAND = '按需发货',
  PER_ORDER = '按单发货',
  // PROCUREMENT = '采购意向订单',
  // DROP_SHIPPING = '一键代发',
}
// 新品采购收货类型
export enum newPurchaseOrderType {
  NORMAL = 1, // 普通订单
  URGENT = 3, // 急件订单
  PER_ORDER = 6, // 按单发货
}

export enum newPurchaseOrderTypeName {
  NORMAL = '普通订单',
  URGENT = '急件订单',
  PER_ORDER = '按单发货',
}

export enum purchaseSubscriptionType {
  BASE = 1, // 基订
  ADDITIONAL = 2, // 添订
}

export enum purchaseSubscriptionTypeName {
  BASE = '基订',
  ADDITIONAL = '添订',
}

export enum purchaseResponseStatus {
  UNREPORTED = 1, // 未回告
  REPORTED_PENDING_SHIPMENT = 2, // 已回告待发货
  SHIPPED_PENDING_RECEIPT = 3, // 已发货待收货
  PARTIAL_RECEIPT = 4, // 部分到货
  COMPLETED = 5, // 已完成
  CLOSED = 6, // 已了结
  PARTIAL_COMPLETION = 7, // 部分完成
  // PARTIAL_CLOSURE = 8, // 部分了结
}

export enum purchaseResponseStatusName {
  UNREPORTED = '未回告',
  REPORTED_PENDING_SHIPMENT = '已回告待发货',
  SHIPPED_PENDING_RECEIPT = '已发货待收货',
  PARTIAL_RECEIPT = '部分到货',
  COMPLETED = '已完成',
  CLOSED = '已了结',
  PARTIAL_COMPLETION = '部分完成、部分了结',
  // PARTIAL_CLOSURE = '',
}
export enum purchaseResponseStatusColor {
  UNREPORTED = 'purple',
  REPORTED_PENDING_SHIPMENT = 'magenta',
  SHIPPED_PENDING_RECEIPT = 'warning',
  PARTIAL_RECEIPT = 'orange',
  COMPLETED = 'green',
  CLOSED = 'cyan',
  PARTIAL_COMPLETION = 'blue',
  // PARTIAL_CLOSURE = '',
}

export enum fulfillmentStatus {
  ALL = 0, // 全部
  PARTIAL_RESERVE = 1, // 部分满足，剩余转预定
  PARTIAL_NO_PRINT = 2, // 部分满足，剩余不再印刷
  NONE_RESERVE = 3, // 全部不满足，剩余转预定
  NONE_NO_PRINT = 4, // 全部不满足，剩余不再印刷
}

export enum fulfillmentStatusName {
  ALL = '全部满足',
  PARTIAL_RESERVE = '部分满足，剩余转预定',
  PARTIAL_NO_PRINT = '部分满足，剩余不再印刷',
  NONE_RESERVE = '全部不满足，剩余转预定',
  NONE_NO_PRINT = '全部不满足，剩余不再印刷',
}

// 采购单-单据类型
export enum purchaseDocumentType {
  NORMAL_ORDER = 1, // 普通订单
  NEW_PRODUCT_PURCHASE, // 新品采购
  PURCHASE_INTENTION, // 采购意向单
  PURCHASE_INTENTION_CONFIRM, // 采购意向确认单
}

//  采购收货类型 与上面差别，多了一个采购意向订单
export enum purchaseTypeOfReceipt {
  NORMAL_ORDER = 1, // 普通订单
  SELF_PICKUP, // 自提
  URGENT_ORDER, // 急件订单
  DIRECT_ORDER, // 直发订单
  ON_DEMAND, // 按需发货
  BY_ORDER, // 按单发货
  // PURCHASE_INTENTION, // 采购意向订单
  ONE_PIECE_DELIVERY, // 一件代发
}

// 采购单-新增-不满足规则
export enum partialDeliveryOptions {
  PARTIAL_AND_CANCEL = 1, // 满足部分发货，其余取消
  PARTIAL_AND_RESERVE = 2, // 满足部分发货，其余转预订
  NONE_AND_CANCEL = 3, // 不满足，全部订数取消
  NONE_AND_RESERVE = 4, // 不满足，全部订数转预订
}
export enum partialDeliveryOptionsName {
  PARTIAL_AND_CANCEL = '满足部分发货，其余取消',
  PARTIAL_AND_RESERVE = '满足部分发货，其余转预订',
  NONE_AND_CANCEL = '不满足，全部订数取消',
  NONE_AND_RESERVE = '不满足，全部订数转预订',
}

// 放单规则
export enum fulfillmentOrderStatus {
  FULL_ORDER_SHIP = 1, // 整单一次性满足放单
  SINGLE_ITEM_SHIP = 2, // 单品满足放单
  PARTIAL_SINGLE_ITEM_SHIP = 3, // 单品部分满足部分放单
}
export enum fulfillmentOrderStatusName {
  FULL_ORDER_SHIP = '整单一次性满足放单',
  SINGLE_ITEM_SHIP = '单品满足放单',
  PARTIAL_SINGLE_ITEM_SHIP = '单品部分满足部分放单',
}
// 分发类型
export enum distributeType {
  DISTRIBUTE_TO_PEOPLE = 1, // 分发到人
  DISTRIBUTE_TO_CLASS = 2, // 分发到班
  DISTRIBUTE_TO_STORE = 3, // 分发到店
  DISTRIBUTE_TO_NOT = 4, // 无需分发
}
export enum distributeTypeName {
  DISTRIBUTE_TO_PEOPLE = '分发到人',
  DISTRIBUTE_TO_CLASS = '分发到班',
  DISTRIBUTE_TO_STORE = '分发到店',
  DISTRIBUTE_TO_NOT = '无需分发',
}
// 图书类型
export enum fulBookType {
  BOOK = 1, // 图书
  NON_BOOK = 2, // 非图
  COMBINATION = 3, // 组合
  PROCESSING = 4, // 加工
  COUPON = 5, // 卡券
  SERVICE = 6, // 服务
  VIRTUAL = 7, // 虚拟
}
export enum fulBookTypeName {
  BOOK = '图书', // 图书
  NON_BOOK = '非图', // 非图
  COMBINATION = '组合', // 组合
  PROCESSING = '加工', // 加工
  COUPON = '卡券', // 卡券
  SERVICE = '服务', // 服务
  VIRTUAL = '虚拟', // 虚拟
}

// 单位名称
export enum bookUnitList {
  INDIVIDUAL = 1,
  VOLUME,
}

export enum bookUnitListName {
  INDIVIDUAL = '个',
  VOLUME = '册',
}

// 采购单详情-订单来源
export enum detailOrderType {
  NORMAL_DEMAND = 1, // 普通需求单   销售订单
  MANUAL_STOCKING = 2, // 人工备货
  STOCKING_SUGGESTION = 3, // 备货建议
}

export enum detailOrderTypeName {
  NORMAL_DEMAND = '销售订单', // 普通需求单
  MANUAL_STOCKING = '人工备货', // 人工备货
  STOCKING_SUGGESTION = '补货建议', // 备货建议  补货建议
}
export enum ERPReturnApplication {
  ERP_RETURN_APPLICATION_PAGE = 1, // ERP退货申请页面
  ALLOWABLE_RETURN_QUERY = 2, // 可退查询
  ALLOWABLE_RETURN_SUGGESTION = 3, // 可退建议
}
export enum ERPReturnApplicationName {
  ERP_RETURN_APPLICATION_PAGE = 'ERP退货申请页面', // ERP退货申请页面
  ALLOWABLE_RETURN_QUERY = '可退查询', // 可退查询
  ALLOWABLE_RETURN_SUGGESTION = '可退建议', // 可退建议
}

// 此处跟上面参数对应不同
export enum cgSupplierType {
  INTERNAL = 1, // 内部供应商
  EXTERNAL, // 外部供应商
  VIRTUAL, // 虚拟供应商
}

// 单据类型 -进退单

export enum returnOrderType {
  RETURN_APPLICATION = 1, // 退货申请单
  DELIVERY_NOTICE = 2, // 发货通知单
  RETURN_ORDER = 3, // 发退单
}

export enum returnOrderTypeName {
  RETURN_APPLICATION = '退货申请单',
  DELIVERY_NOTICE = '发货通知单',
  RETURN_ORDER = '发退单',
}

// 单据类型对应的单据状态····
// 单据类型为申请单状态 退货申请单
export enum returnSubmissionStatus {
  PENDING_SUBMISSION = 1, // 待提交
  PENDING_REVIEW, // 待审核
  APPROVED, // 通过
  REJECTED, // 驳回
  COMPLETED, // 完成
}
export enum returnSubmissionStatusName {
  PENDING_SUBMISSION = '待提交',
  PENDING_REVIEW = '待审核',
  APPROVED = '通过',
  REJECTED = '驳回',
  COMPLETED = '完成',
}
// 单据类型为库存作业状态 发货通知单
export enum returnDistributionStatus {
  PENDING_ASSIGNMENT = 1, // 待分配
  PENDING_DISTRIBUTION, // 待分发
  DISTRIBUTED, // 已分发
  SHIPPED, // 已发货
  COMPLETED, // 已完结
  CANCELED, // 已取消
}
export enum returnDistributionStatusName {
  PENDING_ASSIGNMENT = '待分配',
  PENDING_DISTRIBUTION = '待分发',
  DISTRIBUTED = '已分发',
  SHIPPED = '已发货',
  COMPLETED = '已完结',
  CANCELED = '已取消',
}

// 进退单状态枚举
export enum ReturnStatus {
  PENDING_SHIPPING = 1, // 待出库
  SHIPPED_PENDING_CONFIRMATION, // 已出库待确认
  RETURN_COMPLETED, // 完成退货
}

// 退货状态显示名称枚举
export enum ReturnStatusName {
  PENDING_SHIPPING = '待出库',
  SHIPPED_PENDING_CONFIRMATION = '已出库待确认',
  RETURN_COMPLETED = '完成退货',
}

// 发退单状态还没定下来后续加上

export enum CategoryNumber {
  EDITION = 1, // 版别
  CATEGORY = 2, // 类目
  PRODUCT = 3, // 商品
}

export enum CategoryNumberName {
  EDITION = '版别范围',
  CATEGORY = '类目范围',
  PRODUCT = '商品范围',
}
/**
 * 功能：供应商通知单数据类型 map  1.协同平台,2.ERP手动创建，3.系统创建
 */
export enum MapDataSource {
  协同平台 = 1,
  ERP手动创建 = 2,
  系统创建 = 3,
}

/**
 * 功能：供应商通知单数据类型 list  1.协同平台,2.ERP手动创建，3.系统创建
 */
export const ListDataSource = Object.freeze(enumToList({ MapDataSource }))

/**
 * 功能: 收货方式 连锁店，map 1直发，2收货入库，3代发
 */
export enum MapDeliveryMethod {
  // 直发 = 1,
  即进即发 = 2,
  // 代发 = 3,
  普通入库 = 4,
}

/**
 * 功能: 收货方式 省店，1直发，2即进即发，3代发 ，4普通入库(必填)
 */
export enum MapDeliveryMethodProvincials {
  // 直发 = 1,
  即进即发 = 2,
  // 代发 = 3,
  普通入库 = 4,
}

export enum MapDeliveryMethodChain {
  // DirectDelivery = 1, // 直发
  // ProxyDelivery = 3, // 代发
  NormalWarehousing = 4, // 普通入库
}

export enum MapDeliveryMethodChainName {
  // DirectDelivery = '直发', // 直发
  // ProxyDelivery = '代发', // 代发
  NormalWarehousing = '普通入库', // 普通入库
}
// 	收货优先级（5-普通、7-急、9-紧急）
export enum MapPriorityLevel {
  Normal = 5, // 普通
  Urgent = 7, // 急
  Emergency = 9, // 紧急
}

// 文本枚举（用于显示/界面）
export enum MapPriorityLevelName {
  Normal = '普通', // 普通
  Urgent = '急', // 急
  Emergency = '紧急', // 紧急
}
/**
 * 功能: 收货方式（省店）：1直发，2即进即发，3代发 ，4普通入库(必填)
 */
export enum MapDeliveryMethodProvincial {
  // DirectDelivery = 1, // 直发
  ImmediateDelivery = 2, // 即进即发
  // ProxyDelivery = 3, // 代发
  NormalWarehousing = 4, // 普通入库
}

export enum MapDeliveryMethodProvincialName {
  // DirectDelivery = '直发', // 直发
  ImmediateDelivery = '即进即发', // 即进即发
  // ProxyDelivery = '代发', // 代发
  NormalWarehousing = '普通入库', // 普通入库
}

/**
 * 功能：收货方式，list 1直发，2收货入库，3代发
 */
export const ListDeliveryMethod = Object.freeze(enumToList({ MapDeliveryMethod }))

/**
 * 功能：异常标记 map 0: 无异常 1:有异常
 */
export enum MapExceptionFlag {
  无异常 = 0,
  有异常 = 1,
}

/**
 * 功能：快递公司列表
 */
export const ListExpressCompany = [
  { value: '顺丰快递', label: '顺丰快递' },
  { value: '圆通快递', label: '圆通快递' },
  { value: '中通快递', label: '中通快递' },
  { value: '申通快递', label: '申通快递' },
  { value: '韵达快递', label: '韵达快递' },
]

/**
 * 功能：是否为赠品 map 0：否，1：是
 */
export enum MapIsGiveaway {
  否 = 0,
  是 = 1,
}

/**
 * 功能：异常类型 map 0:无异常 1:多收品种 2:多发数量 3:数量短少
 */
export enum MapExceptionType {
  无异常 = 0,
  多收品种 = 1,
  多发数量 = 2,
  数量短少 = 3,
}

/**
 * 功能：异常类型  0:无异常 1:数量短少,2:多发数量，3：多发品种',
 */
export enum MapExceptionTypeTwo {
  无异常 = 0,
  数量短少 = 1,
  多发数量 = 2,
  多发品种 = 3,
}

/**
 * 功能：异常处理方式 map 1接收、2拒收、3、重新发起采购、4、品种替换、5品种转移
 */
export enum MapExceptionResult {
  接收 = 1,
  拒收 = 2,
  重新发起采购 = 3,
  品种替换 = 4,
  品种转移 = 5,
}

// 异常处理方式：1无异常、2拒收、3、接收补采购（多收）、4、品种替换、5品种转移、6 低价入库、7赠品入库、8、重新发起采购（短少），9 了结
export enum MapExceptionHandling {
  无异常 = 1,
  拒收 = 2,
  接收补采购 = 3,
  品种替换 = 4,
  品种转移 = 5,
  低价入库 = 6,
  赠品入库 = 7,
  重新发起采购 = 8,
  了结 = 9,
}

export enum MapExceptionHandlings {
  NO_EXCEPTION = 1, // 无异常
  REJECT = 2, // 拒收
  ACCEPT_AND_REORDER = 3, // 接收补采购
  VARIETY_REPLACEMENT = 4, // 品种替换
  VARIETY_TRANSFER = 5, // 品种转移
  LOW_PRICE_STORAGE = 6, // 低价入库
  GIFT_STORAGE = 7, // 赠品入库
  REPURCHASE = 8, // 重新发起采购
  CLOSED = 9, // 了结
}

export enum MapExceptionHandlingsName {
  NO_EXCEPTION = '无异常',
  REJECT = '拒收',
  ACCEPT_AND_REORDER = '接收补采购',
  VARIETY_REPLACEMENT = '品种替换',
  VARIETY_TRANSFER = '品种转移',
  LOW_PRICE_STORAGE = '低价入库',
  GIFT_STORAGE = '赠品入库',
  REPURCHASE = '重新发起采购',
  CLOSED = '了结',
}

/**
 * 功能：	商品状态(1待确认、4已确认)
 */
export enum MapProductLineStatus {
  待确认 = 1,
  已确认 = 4,
}

export enum BookType {
  NORMAL_BOOK = 1, // 普通图书
  TEXTBOOK = 2, // 教材
  IMAGE_HOLOFOLDER = 3, // 图片活页
  MAGAZINE = 4, // 期刊杂志
  IMPORTED_BOOK = 5, // 进口图书
}
export enum BookTypeName {
  NORMAL_BOOK = '普通图书',
  TEXTBOOK = '教材',
  IMAGE_HOLOFOLDER = '图片活页',
  MAGAZINE = '期刊杂志',
  IMPORTED_BOOK = '进口图书',
}

export enum ProductFeature {
  TEMPORARY_SALE_DAYS = 1, // 临保多少天可售
  SINGLE_PRODUCT_SN_TRACEABILITY = 2, // 单品SN码追溯
}

export enum ProductFeatureName {
  TEMPORARY_SALE_DAYS = '临保多少天可售',
  SINGLE_PRODUCT_SN_TRACEABILITY = '单品SN码追溯',
}

export enum ReceiptStatus {
  NOT_RECEIVED = 1, // 未收货
  PARTIALLY_RECEIVED = 2, // 部分收货
  FULLY_RECEIVED = 3, // 全部收货
  COMPLETED = 4, // 了结
}

export enum ReceiptStatusName {
  NOT_RECEIVED = '未收货',
  PARTIALLY_RECEIVED = '部分收货',
  FULLY_RECEIVED = '全部收货',
  COMPLETED = '了结',
}

// / 收货单列表
// 订单状态枚举
export enum attributeCategoryOrderStatus {
  // TOBE_RECEIVED = 1,
  // CONFIRMED = 2,
  RECEIVED = 3,
}

export enum attributeCategoryOrderStatusName {
  // TOBE_RECEIVED = '待收货',
  // CONFIRMED = '已到货确认',
  RECEIVED = '已收货',
}

export enum taskSource {
  供应商发货清单 = 1,
  采购单 = 2,
}

export enum documentType {
  NORMAL_ORDER = 1,
  NEW_PRODUCT_PROCUREMENT = 2,
  PROCUREMENT_INTENTION = 3,
  PROCUREMENT_INTENTION_CONFIRMATION = 4,
}

export enum documentTypeName {
  NORMAL_ORDER = '普通订单',
  NEW_PRODUCT_PROCUREMENT = '新品采购',
  PROCUREMENT_INTENTION = '采购意向单',
  PROCUREMENT_INTENTION_CONFIRMATION = '采购意向确认单',
}

export enum unitPriceList {
  最近采购折扣 = 1,
  最低采购折扣 = 2,
  采购折扣 = 3,
}

export enum productRangeTypeList {
  全部商品 = 1,
  按类目 = 2,
  指定商品 = 3,
}

export enum statusType {
  PENDING = 0, // 待确认
  CONFIRMED = 1, // 已确认
  REJECTED = 2, // 驳回
}

// 状态名称枚举（用于UI显示）
export enum statusTypeName {
  PENDING = '待确认',
  CONFIRMED = '已确认',
  REJECTED = '驳回',
}

export enum newProductConfirmationStatus {
  DRAFT, //草稿
  SUBMITTED, //待确认
  CONFIRMED, //已确认
  DENY, //否认
}
export enum newProductConfirmationStatusName {
  DRAFT = '草稿',
  SUBMITTED = '待确认',
  CONFIRMED = '已确认',
  DENY = '否认',
}
export enum newProductConfirmationStatusColor {
  DRAFT = 'orange',
  SUBMITTED = 'blue',
  CONFIRMED = 'green',
  DENY = 'red',
}
